import Header from "@components/Header.jsx";
import React, { useEffect, useState } from "react";
import { Table, Tag } from "antd";
import dayjs from "dayjs";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "@/firebaseConfig";
import {useAuth} from "@/utils/auth.jsx";

const statusColors = {
    pending: "orange",
    approved: "green",
    rejected: "red",
};

const OrdersPage = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const {user} = useAuth();

    useEffect(() => {
        if (!user.uid) return;

        const q = query(collection(db, "transactions"), where("userId", "==", user.uid));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                createdAt: doc.data().createdAt?.toDate(),
            }));
            setTransactions(data);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [user.uid]);

    const columns = [
        {
            title: "Date",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (date) => date ? dayjs(date).format("YYYY-MM-DD HH:mm") : "—",
            sorter: (a, b) => (a.createdAt?.getTime() || 0) - (b.createdAt?.getTime() || 0),
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (amount) => `$${amount.toFixed(2)}`,
            sorter: (a, b) => a.amount - b.amount,
        },
        {
            title: "Payment Method",
            dataIndex: "method",
            key: "method",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => <Tag color={statusColors[status] || "default"}>{status}</Tag>,
            filters: [
                { text: 'Pending', value: 'pending' },
                { text: 'Approved', value: 'approved' },
                { text: 'Rejected', value: 'rejected' },
            ],
            onFilter: (value, record) => record.status === value,
        },
        {
            title: "Admin Comment",
            dataIndex: "review",
            key: "review",
            render: (text) => text || "—",
        },
    ];
    return (
        <div className={`orders-page`}>
            <div className={`wrapper`}>
                    <div className={`page page-app`}>
                        <Header title='Orders' />
                        <Table
                            rowKey="id"
                            loading={loading}
                            dataSource={transactions}
                            columns={columns}
                            pagination={{ pageSize: 10 }}
                            locale={{ emptyText: "No transactions found" }}
                        />
                    </div>
            </div>

        </div>

    )
}

export default OrdersPage;